import React, { useState, useContext } from 'react'
import { motion } from 'framer-motion'
/*COMPONENTS */
import SidebarEl from '../../components/SidebarEl'
import styled from 'styled-components'

import MobileMenu from '../../components/MobileMenu'
import Header from '../../components/Header'
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { ToastContainer, toast } from 'react-toastify';
import app from '../../firebase/config'
import api from '../../services/api'
import { useNavigate } from 'react-router-dom'
import TableListButtons from '../../components/TableListButtons'
import { PagesContext } from '../../context/pages'
import ModalEditButton from '../../components/ModalEditButton'
import Input from '../../components/Input'

import Filter from '../../components/Filter'

const CardWrapper = styled.section`
    background-color: #fafafa;
    display: flex;

   
    .colum_primary{ 
        flex:0.1;
    }


    .colum_secondary{
        padding: 1.7rem;

        display: flex;
        flex:1;
        height: 100vh;
        flex-direction: column;
        width: 100%;
    }

    @media screen and (max-width:720px){
    .colum_primary{ 
        flex:0;

    }

        .colum_secondary{
        display: flex;
        flex:1;
        flex-direction: column;
        width: 100%;
    }
    }

`
const FixWidthSidebar = styled.div`
    display: block;
    width: 130px;
    @media screen and (min-width:1800px){
        display: block;
        width: 90px;
    }

    @media screen and (max-width:820px){
        display: none;
    }


`
const CardInput = styled.section`

    display: flex;
    width: 100%;
    margin-bottom: 0.9em;


    input,select{
        width: 100%;
        height: 50px;
        border-radius: 10px;
    }

    div > label{
        font-size: 0.9rem;
    }

    .textPrimary{
        color: black;
        font-family: "Poppins";
        font-weight: 500;
        margin-bottom: 0rem;
        font-size: 1.2rem;
    }

    div{
        margin-right:1.5rem;
    }

    @media screen and (max-width:720px){
        flex-direction: column;
        div{
            margin-left: 0rem;
        }

    }


`


const ButtonPages = () => {
    const navigate = useNavigate()
    const { getAllButtons, showModalEditButton, setShowModalEditButton, getButtonsByName } = useContext(PagesContext)
    const [data] = useState([
        {
            name: "Id"
        },
        {
            name: "Nome"
        },
        {
            name: "Preview"
        },
        {
            name: "Editar"
        },
        {
            name: "Excluir"
        },
    ])
    const [modalShow, setModalShow] = useState(false)
    const [button] = useState([
        {
            name: "",
            image: ""
        }
    ])

    const handleInput = (name, value) => {

        button[0][name] = value

    }
    const handleImage = (file) => {

        if (file) {

            const { type } = file

            const supportedTypes = ["image/png", "image/jpg", "image/jpeg"]
            const verifySupportedType = supportedTypes.includes(type)


            if (!verifySupportedType) {
                return toast.error("Formato de imagem não suportado!")
            }

            const reader = new FileReader()
            reader.readAsDataURL(file)
            reader.onload = async () => {
                button[0]["image"] = file
                // console.log(imagesFirebase)
            }

        }

    }
    const handleSave = async () => {


        const hasEmptyField = button.some(item =>
            Object.values(item).some(value => value === "")
        );

        if (hasEmptyField) {
            return toast.error("Existem campos vazios!", {
                autoClose: 1500
            });
        } else {
            await storageImages()
            window.location.href = "/dashboard/button"
        }



    }
    const storageImages = async (id, images) => {

        const loadingToastId = toast.loading("Processando Botão...");

        return app.storage().ref(`/pages/buttons/${button[0].name}`).put(button[0].image)
            .then(() => {
                console.log(`Imagem ${button[0].name} carregada com sucesso`);
                return app.storage().ref(`/pages/buttons/${button[0].name}`).getDownloadURL();
            })
            .then(image => {
                toast.update(loadingToastId, {
                    render: "Botão inserido com sucesso!",
                    type: "success",
                    isLoading: false,
                    autoClose: 1000
                });
                return api.post("/buttons/storage", {
                    name: button[0].name,
                    image: image
                })


            })
            .catch(error => {
                console.error(`Erro ao carregar a imagem ${button[0].name}:`, error);
            });


    }


    function ModalPage(props) {
        return (
            <Modal
                {...props}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Informações do botão
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <CardInput>
                        <Input name={"Nome do botão *"} maxLength={16} onChange={(e) => handleInput("name", e.target.value)} />
                        <Input name={"Icone do botão *"} accept={".png, .jpg, .jpeg"} type={"file"} onChange={(e) => handleImage(e.target.files[0])} />

                    </CardInput>

                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={() => { handleSave() }}>Salvar</Button>
                </Modal.Footer>
            </Modal>
        );
    }


    return (
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
        >
            <ToastContainer />
            <CardWrapper>
                <div className='colum_primary'>
                    <SidebarEl />
                </div>
                <FixWidthSidebar />

                <div className='colum_secondary'>
                    <Header name={"Meus Botões"} />
                    <Filter onChange={(e) => getButtonsByName(e.target.value)} buttonName={"Adicionar"} onClick={() => setModalShow(true)} type={1} />
                    <TableListButtons structure={data} />

                </div>

                <MobileMenu />

                <ModalPage
                    show={modalShow}
                    onHide={() => setModalShow(false)}
                />
                <ModalEditButton
                    show={showModalEditButton}
                    onHide={() => setShowModalEditButton(false)}

                />

            </CardWrapper>
        </motion.div>

    )
}

export default ButtonPages